import { render, staticRenderFns } from "./ActionOpenChatSocial.vue?vue&type=template&id=3cce5fa2"
import script from "./ActionOpenChatSocial.vue?vue&type=script&lang=js"
export * from "./ActionOpenChatSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports